;(function () {
  angular.module('contrast.org-stats').controller('OrgStatsCtrl', OrgStatsCtrl)

  function OrgStatsCtrl(
    permissions,
    OrgStatsService,
    LoadFilterRouteService,
    ORG_STATS_CONSTANTS
  ) {
    'ngInject'

    var vm = this

    angular.extend(vm, {
      licenses: {
        data: {},
        donutConfig: {
          overall: {}
        }
      },
      apps: {
        breakdowns: ORG_STATS_CONSTANTS.APP_BREAKDOWN_SELECT,
        breakdown: ORG_STATS_CONSTANTS.APP_BREAKDOWN_SELECT[0],
        data: {},
        donutConfig: {}
      },
      servers: {
        breakdowns: ORG_STATS_CONSTANTS.SERVER_BREAKDOWN_SELECT,
        breakdown: ORG_STATS_CONSTANTS.SERVER_BREAKDOWN_SELECT[0],
        data: {},
        donutConfig: {}
      },
      loading: {
        licenses: true,
        apps: true,
        servers: true
      },
      reloading: {
        apps: false,
        servers: false
      }
    })

    angular.extend(vm, {
      onAppBreakdownChange: onAppBreakdownChange,
      onServerBreakdownChange: onServerBreakdownChange,
      goToUnlicensedApps: LoadFilterRouteService.goToUnlicensedApps
    })

    function init() {
      if (permissions.hasPermission('ADMIN')) {
        _getLicenseStats()
        _getAppStats(vm.apps.breakdown.keycode)
        _getServerStatsBreakdown(vm.servers.breakdown.keycode)
      }
    }

    function onAppBreakdownChange(item) {
      vm.reloading.apps = true
      _getAppStats(item.keycode)
    }

    function onServerBreakdownChange(item) {
      vm.reloading.servers = true
      _getServerStatsBreakdown(item.keycode)
    }

    function _getLicenseStats() {
      vm.loading.licenses = true
      vm.loading.licensesPromise = OrgStatsService.getLicenseStats()
        .then(function (stats) {
          vm.licenses.data = stats.data
          vm.licenses.donutConfig = stats.donutConfig
        })
        .finally(function () {
          vm.loading.licenses = false
        })
    }

    function _getAppStats(breakdown) {
      vm.loading.apps = true
      vm.loading.appsPromise = OrgStatsService.getAppStats([
        ORG_STATS_CONSTANTS.APP_BREAKDOWNS.LANGUAGES,
        breakdown
      ])
        .then(function (stats) {
          vm.apps.data = stats.data
          vm.apps.donutConfig = stats.donutConfig
        })
        .finally(function () {
          vm.loading.apps = false
          vm.reloading.apps = false
        })
    }

    function _getServerStatsBreakdown(breakdown) {
      vm.loading.servers = true
      vm.loading.serversPromise = OrgStatsService.getServerStatsBreakdown([
        breakdown
      ])
        .then(function (stats) {
          vm.servers.data = stats.breakdown
          vm.servers.donutConfig = stats.donutConfig
        })
        .finally(function () {
          vm.loading.servers = false
          vm.reloading.servers = false
        })
    }

    init()
  }
})()
